var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loadingSpinner
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.apiError
      ? _c(
          "div",
          { staticClass: "alert alert-danger p-2", attrs: { role: "alert" } },
          [
            _vm._v(
              " An error occurred while fetching data. Please try again later. "
            ),
          ]
        )
      : _vm._e(),
    !_vm.loadingSpinner && !_vm.apiError
      ? _c(
          "div",
          [
            _c(
              "app-collapse",
              { attrs: { accordion: "" } },
              [
                _c(
                  "app-collapse-item",
                  { attrs: { title: "Summary" } },
                  [
                    _c("Summary", {
                      attrs: { JobCard: _vm.jobId },
                      on: {
                        status: _vm.getStatus,
                        bomStatus: _vm.getBOMStatus,
                        operationStepsStatus: _vm.getOperationStepStatus,
                        warehouseId: _vm.getWarehouse,
                        startDate: _vm.getDate,
                      },
                    }),
                    _c("SalesOrders", {
                      attrs: {
                        salesOrders: _vm.jobId.salesOrderDetail,
                        pushOrders: _vm.jobId.pushOrderDetail,
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "app-collapse-item",
                  { attrs: { title: "Bill Of Materials" } },
                  [
                    _c("BomTb", {
                      attrs: { JobCard: _vm.jobId },
                      on: { onchange: _vm.bomChanged },
                    }),
                  ],
                  1
                ),
                _c(
                  "app-collapse-item",
                  { attrs: { title: "Operation Steps" } },
                  [
                    _c("Operationprocess", {
                      on: { onchange: _vm.operationChange },
                    }),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("b-table", {
                          staticClass: "mt-2",
                          attrs: {
                            striped: "",
                            hover: "",
                            responsive: "",
                            "per-page": _vm.perPage,
                            "current-page": _vm.currentPage,
                            items: _vm.jobId.operationSteps,
                            fields: _vm.fields,
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection,
                            filter: _vm.filter,
                            "filter-included-fields": _vm.filterOn,
                          },
                          on: {
                            "update:sortBy": function ($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function ($event) {
                              _vm.sortBy = $event
                            },
                            "update:sortDesc": function ($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function ($event) {
                              _vm.sortDesc = $event
                            },
                            filtered: _vm.onFiltered,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(show_details)",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "vs-checkbox-con",
                                        attrs: { plain: "" },
                                        on: { change: row.toggleDetails },
                                        model: {
                                          value: row.detailsShowing,
                                          callback: function ($$v) {
                                            _vm.$set(row, "detailsShowing", $$v)
                                          },
                                          expression: "row.detailsShowing",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "vs-checkbox" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "vs-checkbox--check",
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "vs-icon feather icon-check",
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "vs-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                row.detailsShowing
                                                  ? "Hide"
                                                  : "Show"
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "row-details",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "b-card",
                                      [
                                        _c(
                                          "b-row",
                                          { staticClass: "mb-2" },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3",
                                                attrs: { md: "6" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center mb-2",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "feather icon-users mr-2 text-primary",
                                                        }),
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Assigned Staff:"
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("v-select", {
                                                      key: row.item.id,
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        options:
                                                          _vm.formattedUsers,
                                                        reduce: function (
                                                          user
                                                        ) {
                                                          return user.id
                                                        },
                                                        label: "name",
                                                        multiple: "",
                                                        clearable: true,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleStaffChange(
                                                            row.item
                                                              .selectedStaff,
                                                            row.item
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          row.item
                                                            .selectedStaff,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "selectedStaff",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.selectedStaff",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-3",
                                                attrs: { md: "6" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex align-items-center mb-2",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "feather icon-tool mr-2 text-success",
                                                        }),
                                                        _c("strong", [
                                                          _vm._v("Equipment:"),
                                                        ]),
                                                      ]
                                                    ),
                                                    _c("v-select", {
                                                      key: row.item.id,
                                                      staticClass: "mb-3",
                                                      attrs: {
                                                        options:
                                                          _vm.formattedEquipment,
                                                        reduce: function (
                                                          equipment
                                                        ) {
                                                          return equipment.id
                                                        },
                                                        label: "name",
                                                        multiple: "",
                                                        clearable: false,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleEquipmentChange(
                                                            row.item
                                                              .selectedEquipment,
                                                            row.item
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          row.item
                                                            .selectedEquipment,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "selectedEquipment",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.selectedEquipment",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mb-1",
                                                attrs: { md: "4" },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center",
                                                  },
                                                  [
                                                    _c(
                                                      "strong",
                                                      { staticClass: "mr-2" },
                                                      [_vm._v("Status: ")]
                                                    ),
                                                    _c("b-form-select", {
                                                      attrs: {
                                                        options: _vm.options,
                                                      },
                                                      model: {
                                                        value: row.item.status,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "status",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.status",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c("b-col", {
                                              staticClass: "mb-1",
                                              attrs: { md: "4" },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-card",
                                          [
                                            _c(
                                              "b-card-body",
                                              [
                                                _c(
                                                  "b-row",
                                                  [
                                                    _c(
                                                      "b-col",
                                                      { attrs: { md: "3" } },
                                                      [
                                                        _c(
                                                          "h6",
                                                          {
                                                            staticClass: "mb-2",
                                                          },
                                                          [_vm._v("Comment:")]
                                                        ),
                                                        _c("b-form-input", {
                                                          staticClass: "w-100",
                                                          model: {
                                                            value:
                                                              row.item.comment,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row.item,
                                                                "comment",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row.item.comment",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "b-col",
                                                      { attrs: { cols: "12" } },
                                                      [_c("hr")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "b-button",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-secondary",
                                            },
                                            on: { click: row.toggleDetails },
                                          },
                                          [_vm._v(" Hide Details ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(avatar)",
                                fn: function (data) {
                                  return [
                                    _c("b-avatar", {
                                      attrs: { src: data.value },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(status)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "b-badge",
                                      {
                                        attrs: {
                                          variant:
                                            _vm.status[1][data.item.value],
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.status[0][data.item.status]
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(actions)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass: "m-1",
                                        attrs: {
                                          variant: "link",
                                          "toggle-class": "p-0",
                                          "no-caret": "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function () {
                                                return [
                                                  _c("feather-icon", {
                                                    staticClass:
                                                      "align-middle text-body",
                                                    attrs: {
                                                      icon: "MoreVerticalIcon",
                                                      size: "16",
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "b-dropdown-item",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName: "v-b-modal.modal-edit",
                                                modifiers: {
                                                  "modal-edit": true,
                                                },
                                              },
                                            ],
                                            attrs: {
                                              to: _vm.addtimesheet(
                                                data.item.id,
                                                _vm.jobId.id
                                              ),
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-50",
                                              attrs: { icon: "ClockIcon" },
                                            }),
                                            _c("span", [_vm._v("Time sheet")]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1293234000
                          ),
                        }),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center mb-1" },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticStyle: {
                                    width: "3rem",
                                    height: "3rem",
                                  },
                                  attrs: {
                                    variant: "success",
                                    label: "Spinning",
                                    block: "",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("b-pagination", {
                          staticClass: "my-0",
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.perPage,
                            align: "center",
                            size: "sm",
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function ($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage",
                          },
                        }),
                        _c("b-form-group", [
                          _vm._v(
                            " Showing " +
                              _vm._s(
                                _vm.totalRows > 0
                                  ? _vm.perPage * (_vm.currentPage - 1) + 1
                                  : 0
                              ) +
                              " to " +
                              _vm._s(
                                _vm.totalRows > 0
                                  ? Math.min(
                                      _vm.perPage * _vm.currentPage,
                                      _vm.totalRows
                                    )
                                  : 0
                              ) +
                              " of " +
                              _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                              " entries "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "app-collapse-item",
                  { attrs: { title: "Cost" } },
                  [_c("TotalCost", { attrs: { data: _vm.jobId } })],
                  1
                ),
                _c(
                  "app-collapse-item",
                  { attrs: { title: "Documents" } },
                  [_c("UploadDocTabs", { attrs: { id: _vm.id } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-container",
              { staticClass: "d-flex justify-content-center py-2" },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        !_vm.loading
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                attrs: { variant: "primary" },
                                on: { click: _vm.updateJobCard },
                              },
                              [_c("span", [_vm._v("Update Job Card")])]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  staticClass: "mx-2",
                                  attrs: { large: "" },
                                })
                              : _vm._e(),
                            _vm.loading
                              ? _c("span", [_vm._v("Loading...")])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }